module.exports = __webpack_public_path__ + "img/vvf.fd2fbc86.png";